angular.module('natgeo').controller('Level3SplashScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'SoundEngine', 'Analytics',
function Level3SplashScreen($scope, element, ScreenFactory, manager, container, SoundEngine, Analytics)
{
	var screen = ScreenFactory( 'level3_splash', element );
	
	screen.once('introBefore', function()
	{
		anim8.save('level3SplashBee1Intro', {
			keyframe: {
				'0': {
					translate: 0,
					scale: 0.8,
					easing: 'linear'
				},
				'100': {
					scale: 0.9,
					translate: {
						x: 1300,
						y: -200
					}
				},
				'8,16,24,32,40,48,56,64,72,80,88,96': {
					translateY: -3
				},
				'4,12,20,28,36,44,52,60,68,76,84,92': {
					translateY: 3
				}
			}
		}, {
			duration: 7000,
			delay: 1000
		});

		anim8.save('level3SplashBee2Intro', {
			keyframe: {
				'0': {
					scale: 0.9,
					translate: 0,
					easing: 'linear'
				},
				'100': {
					scale: 1.4,
					translate: {
						x: 1300,
						y: -600
					}
				},
				'8,16,24,32,40,48,56,64,72,80,88,96': {
					translateY: -3
				},
				'4,12,20,28,36,44,52,60,68,76,84,92': {
					translateY: 3
				}
			}
		}, {
			duration: 3000,
			delay: 2000
		});

		anim8.save('level3SplashBee3Intro', {
			keyframe: {
				'0': {
					scale: {x: -0.9, y: 0.9},
					translate: {x: 220, y: -180},
					easing: 'linear'
				},
				'100': {
					scale: {x: -1.0, y: 1.0},
					translate: 0,
					translateY: 0
				},
				'12,36,60,84': {
					translateY: -3
				},
				'24,48,72,96': {
					translateY: 3
				}
			}
		}, {
			duration: 2000,
			delay: 7000
		});

		anim8.save('level3SplashBeeBounce', {
			keyframe: {
				'0,100': {
					translateY: 0
				},
				'40': {
					translateY: 5
				}
			},
			units: {
				translateY: '%'
			}
		}, {
			repeat: Number.POSITIVE_INFINITY,
			duration: 2000
		});

		anim8.save('level3SplashBee3Outro', {
			keyframe: {
				from: {
					scale: {x: -1, y: 1}
				},
				to: {
					scale: 0
				}	
			}
		}, {
			duration: 750
		});

	});

	// How long to wait after intro before progressing to the next screen (in milliseconds).
	var WAIT_TIME = 1 * 1000;

	// Wait X seconds after intro has finished before progressing to the next screen
	screen.on('introEnd', function()
	{
		setTimeout(function()
		{
			$scope.begin(); 

		}, WAIT_TIME);

		Analytics.start('Robotic Bees');
	});

	// Beginning of the screen, play the whip!
	screen.on('introBegin', function()
	{
		SoundEngine.play( 'bee-fly', {delay:1500} );
	});
	
	// The next screen is the define screen
	$scope.begin = function()
	{
		manager.transition('level3_define');
	};
	
}]);